var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio"},[_c('div',{staticClass:"fb fb-cross-center",on:{"click":function($event){return _vm.methodSelectItem(_vm.selected)}}},[_c('i',{staticClass:"iconfont font-48",class:{
        'c-006AFE': _vm.selected,
        'c-171A1D-40': !_vm.selected && !_vm.disabled,
        'c-171A1D-12': _vm.disabled
      }},[_vm._v(_vm._s(_vm.selected ? '' : ''))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }